import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class CombinationManagerService {
  environment = EnvironmentService.environment;

  constructor(private http: HttpClient) {
  }

  public combinationGridActionCellSubject: Subject<any> = new Subject();

  setCombinationGridActionCellSubject = (value: any) => { this.combinationGridActionCellSubject.next(value) };

  getCombinationGridActionCellSubject = () => this.combinationGridActionCellSubject.asObservable();

  ImportCombinationManagerTemplate(body: any) {
    return this.http.post(`${this.environment.CombinationManager}/importDetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  CombinationMangerGetList(body: any) {
    return this.http.post(`${this.environment.CombinationManager}/combinationManagerGetList`, body)
      .pipe(map(response => {
        return response;
      }));
  }
  GetCombinationMangerGetList() {
    return this.http.get(`${this.environment.CombinationManager}/combinationManagerGetList`)
      .pipe(map(response => {
        return response;
      }));
  }

  CombinationAdd(body: any) {
    return this.http.post(`${this.environment.CombinationManager}/combinationManagerAdd`, body)
      .pipe(map(response => {
        return response;
      }));
  }

  CombinationManagerAddRelationShip(body: any) {
    return this.http.post(`${this.environment.CombinationManager}/combinationManagerAddRelationship`, body)
      .pipe(map(response => {
        return response;
      }));
  }

  CombinationUpdate(body: any) {
    return this.http.post(`${this.environment.CombinationManager}/combinationManagerUpdateRelationship`, body)
      .pipe(map(response => {
        return response;
      }));
  }


}
